import { useState } from 'react';
import '../scss/upload.scss';
import DocumentSliderModal from './DocumentSliderModal';

const UploadFile = (props) => {
    const { validType, mandatory, addedFiles, setAddedFiles, onFileChange, text, enableDragAndDrop = false, showAttachedFiles = true, label, showFilePreview, onFileRemove, index } = props;
    const [showSliderModal, setShowSliderModal] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const handleFileChange = (event) => {
        const files = event.target.files;
        if (files.length > 0) {
            const newFiles = Array.from(files).map(file => ({
                file,
                name: file.name,
                id: `${file.name}-${Date.now()}`,
                size: file.size,
            }));
            if (onFileChange) {
                onFileChange(newFiles)
            } else {
                setAddedFiles(prevFiles => [...prevFiles, ...newFiles]);
            }
        }
        event.target.value = null; // Clear input to allow re-uploading the same file
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const files = event.dataTransfer.files;
        if (files.length > 0) {
            handleFileChange({ target: { files } });
        }
    };

    const removeFile = (fileId) => {
        if (onFileRemove) {
            onFileRemove(fileId)
        } else {
            setAddedFiles(prevFiles => prevFiles.filter(file => file.id !== fileId));
        }
    };

    const fileInput = (
        <label htmlFor={`fileInput-${index}`} className="file-upload-label w-100">
            <input
                type="file"
                id={`fileInput-${index}`}
                className="d-none"
                accept={validType.join(',')}
                onChange={handleFileChange}
                multiple
            />
            {enableDragAndDrop ? (
                <div
                    className="drag-drop-area text-center"
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                >
                    <p className="drag-drop-text">Drag & drop files here</p>
                    <p className="or-text">or</p>
                    <span className="btn browse-btn">Browse Files</span>
                    <p className="supported-formats-text mt-3">
                        Format supported: {validType.map(type => type.split('/').pop().toUpperCase()).join(', ')}, up to 50 MB
                    </p>
                </div>
            ) : (
                <div className="file-upload-box">
                    <span className="plus-symbol">+</span>
                    <span className="file-upload-text">{text}</span>
                </div>
            )}
        </label>
    );

    const attachedFilesList = (
        showAttachedFiles && addedFiles && addedFiles.length > 0 && (
            <>
                <br />
                <p className="form-label mt-0">Attached Files</p>
                <div className="attached-files-list">
                    {addedFiles.map((file, index) => (
                        <div className="attached-file-item" key={index}>
                            <span
                                className="file-name"
                                onClick={() => {
                                    if (showFilePreview) {
                                        setCurrentIndex(index);
                                        setShowSliderModal(true)
                                    }
                                }}
                            >{file.name}</span>
                            <span className="delete-icon" onClick={() => removeFile(file.id)}>
                                <img
                                    src="/kshemaImages/delete_symbol.png"
                                    alt="delete"
                                    height="18px"
                                    width="auto"
                                />
                            </span>
                        </div>
                    ))}
                </div>
                {showSliderModal && (<DocumentSliderModal
                    currentIndex={currentIndex}
                    setCurrentIndex={setCurrentIndex}
                    onClose={() => { setShowSliderModal(false) }}
                    documents={addedFiles}
                    show={showSliderModal}
                />)}
            </>
        )
    );


    return (
        <>
            <div>
                {label ? (<p className="form-label mt-3">
                    {label}{mandatory && <span className='text-danger'> *</span>}
                </p>) : ""}
                <div className="file-upload-container">
                    {fileInput}
                </div>
                {!enableDragAndDrop && <div className="file-size-info">File Size can not be more than 50 MB</div>}
            </div>
            <div>
                {attachedFilesList}
            </div>
        </>
    );
};

export default UploadFile;